import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddRailPointComponent } from 'src/app/core/dialogs/add-rail-point/add-rail-point.component';
import { DeleteRailPointComponent } from 'src/app/core/dialogs/delete-rail-point/delete-rail-point.component';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { RefreshGridComponent } from 'src/app/core/refresh-grid/refresh-grid.component';
import { FiscalYearService } from 'src/app/service/fiscal-year.service';
import { RailPointService } from 'src/app/service/rail-point.service';

export interface AddDialogData {
	performAction: string;
	page;

	placeholder_fiscalYear: string;
	placeholder_railPointID;
	placeholder_railPointCode: string;
	placeholder_location;
	placeholder_roundTripCost;
}

export interface DeleteRailPointData {
	id: Number;
	railPoint: string;
	page;
}

@Component({
	selector: 'app-rail-points',
	templateUrl: './rail-points.component.html',
	styleUrls: ['./rail-points.component.scss'],
	standalone: false // NOSONAR
})
export class RailPointsComponent implements OnInit {
	frameworkComponents;
	icons;
	rowCount;
	rowData: any[];
	defaultColDef;
	selectedRows: any = [];
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;

	gridApi: any;
	gridColumnApi: any
	setPagination = 'true';

	usertemp: string;
	userInfo: any;
	strUserName;

	successMessage = '';
	errorMessage = '';

	fiscalYears: any = [];
	fiscalYearChosen = '';
	tempData: any[];
	enableGrid: boolean = false;
	paginationPageSize: number = 30;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;

	@ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	context: any;
	columnDefs;

	constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly railPointService: RailPointService,
		public dialog: MatDialog, private readonly  fiscalYearService: FiscalYearService) {
		this.dynamicHeight = 0.665 * (window.innerHeight);

		this.context = {
			componentParent: this
		};
		this.columnDefs = [
			{
				headerName: '', width: 40, maxWidth: 40, minWidth: 40, autoHeight: true, floatingFilterComponent: RefreshGridComponent,
				suppressHeaderMenuButton: true, filter: 'agTextColumnFilter', sortable: false, suppressHeaderFilterButton: true,
				floatingFilterComponentParams: { suppressFilterButton: true }
			},
			{
				headerName: "RAIL POINT", headerClass: "railPoint", field: "railPointCode", width: 205,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "LOCATION", headerClass: "location", field: "location", width: 525,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "ROUND TRIP COST", headerClass: "roundTripCost", field: "roundTripCost", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter',
				floatingFilterComponentParams: { suppressFilterButton: true }
			},
			{
				headerName: "CREATED BY", headerClass: "createdBy", field: "createdBy", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "CREATED ON", headerClass: "created", field: "createdDate", width: 180,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "ACTIONS", headerClass: "editdelete", field: "railpoints_action", width: 120,
				autoHeight: true, cellRenderer: BtnCellRenderer,
				cellRendererParams: {
					clicked: function (_field: any, _act: any) {
						console.info('some')
					}
				}
			}
		];

		this.frameworkComponents = {
			btnCellRenderer: BtnCellRenderer
		};

		this.defaultColDef = {
			minWidth: 100,
			floatingFilter: true,
			wrapText: true
		};

		this.icons = {
			sortUnSort: '<img src="./assets/images/unsort.svg">',
		  };
	}

	ngOnInit(): void { // NOSONAR 

		this.loadFYData();
	}

	loadFYData() {
		this.ngxUiLoaderService.start("loader-01");
		//get fiscal year list - api
		this.fiscalYears = [];

		this.fiscalYearService.getFiscalYearList().subscribe(result => {
			console.info("calling getFiscalYearList");
			if (result?.length > 0) {
				//storing templates data in local
				localStorage.setItem('fiscal-year-data', JSON.stringify(result));
				this.fiscalYears = result;
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}

	display() {
		if (this.fiscalYearChosen) {
			this.enableGrid = true;
			this.rowData = [];
			this.tempData = [];

			this.ngxUiLoaderService.start("loader-01");

			console.info("the selected fiscal year", this.fiscalYearChosen);
			this.railPointService.getDetails(this.fiscalYearChosen).subscribe(railPointsData => {
				railPointsData?.forEach(e => {
					const obj = {
						"railPointID": undefined, "railPointCode": undefined, "location": undefined, "roundTripCost": undefined, "createdDate": undefined, "createdBy": undefined
					};

					obj.railPointID = e.railPointID;
					obj.railPointCode = e.railPointCode;
					obj.location = e.location;
					obj.roundTripCost = e.roundTripCost;
					obj.createdBy = e.createdBy;
					obj.createdDate = e.createdDate;

					this.tempData.push(obj);
					console.info("Rail Point data set to the object")
				});
				this.rowData = this.tempData;
				if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
				this.rowCount = this.rowData.length;
				this.ngxUiLoaderService.stop("loader-01");
			});
		}
		else {
			this.enableGrid = false;
		}
	}

	sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

	getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event: any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}

	refreshData() {
		this.display();
	}

	setUserInfo() {
		//fetch from local-storage
		// this.usertemp = localStorage.getItem('user-info');
		// this.userInfo = JSON.parse(this.usertemp);
		// this.strUserName = this.userInfo[0].strUserName; // Commented to get the same info from APM

		this.usertemp = sessionStorage.getItem('FGA');
		this.userInfo = JSON.parse(this.usertemp);
		this.strUserName = this.userInfo?.user?.userPrincipalName;
	}

	addRailPoint(): void {
		console.info("open dialog");
		this.setUserInfo();		// To set created by user

		const dialogRef = this.dialog.open(AddRailPointComponent, {
			disableClose: true,
			width: '410px',
			data: { performAction: 'AddCell', placeholder: '', placeholder_fiscalYear: this.fiscalYearChosen }
		});

		dialogRef.afterClosed().subscribe(result => {
			

			if (result != undefined && result.event == 'AddCell') {  // NOSONAR
				//API Integration
				const dataArr = {
					"fiscalYear": result.data1,
					"railPointCode": result.data2,
					"location": result.data3,
					"roundTripCost": result.data4,
					"createdBy": this.strUserName
				}

				console.info("data arr", dataArr);

				this.ngxUiLoaderService.start("loader-01");
				this.railPointService.addRailPoint(dataArr).subscribe(result => {

					console.info("result", result);

					if (!result) {
						this.display();

						this.errorMessage = 'Rail Point already exists!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
					else if (result) {
						this.display();
						this.successMessage = 'Rail Point added successfully!';

						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
				});
				this.ngxUiLoaderService.stop("loader-01");
			}
		});
	}

	deleteRailPointRow(val) {
		let railPointCode;
		let id;

		this.rowData.filter(x => x.railPointID == val).forEach(e => {  // NOSONAR
			this.selectedRows.push(e);
			id = e.railPointID;
			railPointCode = e.railPointCode;
		});

		const dialogRef = this.dialog.open(DeleteRailPointComponent, {
			disableClose: true,
			width: '510px',
			data: { id: id, railPoint: railPointCode, page: 'rail point' }
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result != undefined) { // NOSONAR
				
				console.info("data to be deleted:", result.data);

				const deletejson = {
					"railPointID": result.data
				}

				this.deleteRailPoint(deletejson);
				console.info("json", deletejson);
			}
		});
	}

	deleteRailPoint(dataArr) {
		console.info("the delete array in deleterecords", dataArr);
		this.ngxUiLoaderService.start("loader-01");

		this.railPointService.deleteRailPoint(dataArr).subscribe(_result => {
			this.successMessage = 'Deleted Row(s) Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);

			//fetch latest row data after deleting
			this.display();
		});
		this.ngxUiLoaderService.stop("loader-01");
	}

	editRailPointRow(val) {
		let id;
		let railPointCode;
		let location;
		let roundTripCost;

		this.rowData.filter(x => x.railPointID == val).forEach(e => { // NOSONAR
			id = e.railPointID;
			location = e.location;
			railPointCode = e.railPointCode;
			roundTripCost = e.roundTripCost;
		});

		console.info("railPointID", id); console.info("location", location);
		console.info("Rail Point Code", railPointCode); console.info("roundTripCost", roundTripCost);

		const dialogRef = this.dialog.open(AddRailPointComponent, {
			disableClose: true,
			width: '410px',
			data: {
				performAction: 'EditCell', page: 'rail point', placeholder_railPointID: id, placeholder_location: location,
				placeholder_roundTripCost: roundTripCost, placeholder_railPointCode: railPointCode
			}
		});

		this.setUserInfo();		// To set the updatedBy user
		dialogRef.afterClosed().subscribe(result => {
			

			if (result != undefined && result.event == 'EditCell') {  // NOSONAR
				//API Integration
				const dataArr = {
					"railPointID": result.data0,
					"location": result.data1,
					"roundTripCost": result.data2,
					"updatedBy": this.strUserName
				}

				this.ngxUiLoaderService.start("loader-01");
				this.railPointService.editRailPoint(dataArr).subscribe(result => {
					
					if(result){
						this.successMessage = 'Rail Point updated successfully!';
					}else {
						this.errorMessage = "Something went wrong. Please Contact system administrator"
					}
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);

					//fetch latest row data after editing
					this.display();
					// }
				});
				this.ngxUiLoaderService.stop("loader-01");
			}
		});
	}
}